var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUserBeneficiary)?_c('v-chip',{staticClass:"text-uppercase ma-2",attrs:{"color":"#174dc5","label":"","text-color":"white"}},[_vm._v(_vm._s(_vm.contract && _vm.contract.client[0])+"\n")]):_c('support-account')}
var staticRenderFns = []

export { render, staticRenderFns }